/**
 * ScrollToTopButton — appare quando l'utente scorre oltre soglia
 * (default 320px), fisso in basso a destra con scroll fluido al click.
 *
 * Usato in Vg2Shell così è disponibile su tutte le pagine del percorso
 * (CAPISCI, VALUTA, DECIDI, AGISCI) senza modificare le singole pagine.
 */
import React from "react";
import { ArrowUp } from "lucide-react";


export function ScrollToTopButton({ threshold = 320 }) {
  const [visible, setVisible] = React.useState(false);

  React.useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > threshold);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [threshold]);

  const goTop = () =>
    window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <button
      type="button"
      aria-label="Torna in cima"
      onClick={goTop}
      data-testid="vg2-scroll-top"
      className={
        "fixed bottom-6 right-6 z-40 w-11 h-11 rounded-full " +
        "bg-vg2-red hover:bg-[#8F0101] text-white " +
        "shadow-lg flex items-center justify-center " +
        "transition-all duration-200 " +
        (visible
          ? "opacity-100 translate-y-0 pointer-events-auto"
          : "opacity-0 translate-y-3 pointer-events-none")
      }
    >
      <ArrowUp size={20} strokeWidth={2} />
    </button>
  );
}
